import { useEffect, useState } from "react";
import { fetchArticlesData } from "../services/api";

const initialState = {
  articlesData: null,
  articlesDataLoading: false,
  articlesDataError: null,
};

export const useArticlesData = (lang) => {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!lang) {
      setState({
        articlesData: null,
        articlesDataLoading: false,
        articlesDataError:
          "Error! Please provide language parameter in the url.",
      });
      return;
    }

    setState({ data: null, loading: true, error: null });

    fetchArticlesData(lang)
      .then((data) =>
        setState({
          articlesData: data,
          articlesDataLoading: false,
          articlesDataError: null,
        })
      )
      .catch((error) => {
        console.error(error);
        setState({
          articlesData: null,
          articlesDataLoading: false,
          articlesDataError:
            "Error fetching Candidates data 😔 Please refresh.",
        });
      });
  }, [lang]);

  return state;
};
